module.exports = __webpack_public_path__ + "img/card_ip_stipulation78.75d203c3.svg";